import React from 'react';
import type { ComponentType } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { getScreensForStack } from '../shared/navigation/screenRegistry';
import type { ScreenRegistryEntry } from '../shared/navigation/types';
import { getResolvedScreenComponent } from './resolvedScreenMap';
import { AuthDailyMenuScreenRoute, AuthOrderScreenRoute } from './specialRoutes';
import { TabNavigator } from './mainTabs/TabNavigator';

function resolveStackComponent(entry: ScreenRegistryEntry, stack: 'auth' | 'main'): ComponentType {
  if (entry.componentVariant === 'auth_order') {
    return AuthOrderScreenRoute;
  }
  if (entry.componentVariant === 'auth_daily_menu') {
    return AuthDailyMenuScreenRoute;
  }
  if (entry.componentVariant === 'main_tabs') {
    return TabNavigator;
  }
  if (entry.resolvedKey) {
    return getResolvedScreenComponent(entry.resolvedKey);
  }
  throw new Error(`stackScreenFactory: no component for ${entry.name} on ${stack}`);
}

type StackType = ReturnType<typeof createNativeStackNavigator>;

export function renderRegistryStackScreens(
  Stack: StackType,
  stack: 'auth' | 'main',
): React.ReactNode[] {
  return getScreensForStack(stack).map(entry => (
    <Stack.Screen
      key={`${stack}-${entry.name}`}
      name={entry.name}
      component={resolveStackComponent(entry, stack)}
    />
  ));
}
